import Request from "../lib/request";
import { PROJECT_USER_ID } from "../constants/filters";
import {
  BULK_DELETE_API,
  COPY_TRANSACTION_API,
  CREAT_MISSING_OBJECTS_API,
  GET_ITEMS_API,
  IMPORTS_API,
  INIT_API,
  PROJECT_USERS_API,
  STORE_ITEMS_API,
  TRANSACTIONS_API
} from "../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;
const adminBaseUrl = process.env.REACT_APP_API_ADMIN_URL;

export const multiDelete = data => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);

  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${BULK_DELETE_API}`,
    needToken: true,
    data: data
  });
};

export const pettyCashierCopyToAnotherProject = data => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);

  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${COPY_TRANSACTION_API}`,
    needToken: true,
    data: data
  });
};

export const managerCopyToAnotherProject = data => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);

  return Request({
    method: "post",
    url: `${adminBaseUrl}/${PROJECT_USERS_API}/${projectUserId}/${COPY_TRANSACTION_API}`,
    needToken: true,
    data: data
  });
};

export const importFile = data => {
  let formData = new FormData();
  formData.append("file", data.file);
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPORTS_API}/${TRANSACTIONS_API}/${INIT_API}`,
    needToken: true,
    headers: {
      "Content-Type": "multipart/forms-data"
    },
    data: formData
  });
};

export const createMissingObjectsForImportFile = data => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPORTS_API}/${TRANSACTIONS_API}/${CREAT_MISSING_OBJECTS_API}`,
    needToken: true,
    data: data
  });
};

export const getItemsOfImportedFile = data => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPORTS_API}/${TRANSACTIONS_API}/${GET_ITEMS_API}`,
    needToken: true,
    params: data
  });
};

export const storeItemsOfImportedFile = data => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPORTS_API}/${TRANSACTIONS_API}/${STORE_ITEMS_API}`,
    needToken: true,
    data: data
  });
};
